import { createSlice } from '@reduxjs/toolkit'
import { AppColors } from 'resources/AppColors'
import { ParametersTypes } from 'resources/ParametersTypes'
import PatientsService from 'services/PatientsService'
import moment from 'moment'

const initialState = {
  allTimePatientData: [],
  allTimeWeightChart: null,
  firstWeightRegister: null,
  lastWeightRegister: null
}

const weightStatsSlice = createSlice({
  name: 'weightStats',
  initialState,
  reducers: {
    setPatientStatsAllTime(state, action) {
      return { ...state, allTimePatientData: action.payload }
    },
    setWeightChartAllTime(state, action) {
      const dateFormat = "DD/MM/YYYY";

      const weightStatsSortedPerDay = [...action.payload].sort((a, b) =>
        a.timestamp.localeCompare(b.timestamp)
      );

      let weightByDay = {};

      weightStatsSortedPerDay.forEach((data) => {
        const date = data.timestamp.split("T")[0];
        let newData = [];
        if (data.value >= 30 && data.value <= 150) {
          if (weightByDay[date]) {
            newData = weightByDay[date];
          }
          newData.push(data.value);
          weightByDay = { ...weightByDay, [date]: newData };
        }
      });

      let weightMaxValues = [];
      let weightLabels = [];

      Object.keys(weightByDay).map(function (day) {
        weightLabels.push(moment(day).format(dateFormat));
        var max = Math.max(...weightByDay[day]);
        weightMaxValues.push(max);
      });

      let weightObject = {
        values: {
          label: "Pes",
          data: weightMaxValues,
          backgroundColor: AppColors.BLUE_CHART,
          borderColor: AppColors.BLUE_CHART,
        },
        labels: weightLabels,
      };

      return { ...state, allTimeWeightChart: weightObject }
    },
    setFirstWeightRegister(state, action) {
      const moments = action.payload.map(dataPoint => moment(dataPoint.timestamp))
      const firstEntryTimestamp = moment.min(moments).toISOString()

      const firstEntryObject = action.payload.find(dataPoint => moment(dataPoint.timestamp).isSame(moment(firstEntryTimestamp)))

      return { ...state, firstWeightRegister: firstEntryObject }
    },
    setLastWeightRegister(state, action) {
      const moments = action.payload.map(dataPoint => moment(dataPoint.timestamp))
      const lastEntryTimestamp = moment.max(moments).toISOString()
      const lastEntryObject = action.payload.find(dataPoint => moment(dataPoint.timestamp).isSame(moment(lastEntryTimestamp)))

      return { ...state, lastWeightRegister: lastEntryObject }
    },
    resetWeightState(state, action) {
      return initialState
    }
  }
})

export const { setWeightChartAllTime, setPatientStatsAllTime, setFirstWeightRegister, setLastWeightRegister, resetWeightState } =
  weightStatsSlice.actions

export const getWeightStatsAllTime = (patientId) => {
  return async (dispatch) => {
    const { name } = ParametersTypes.WEIGHT
    const { data, status } = await PatientsService.getObservations(name, patientId)
    dispatch(setPatientStatsAllTime({ data, status }))
  }
}

export const generateWeightChartAllTime = (weightData) => {
  return (dispatch) => {
    dispatch(setWeightChartAllTime(weightData))
  }
}

export const setFirstWeightRegisterAction = () => {
  return (dispatch, getState) => {
    const weightState = getState().weightData.allTimePatientData.data
    if (weightState?.length > 0) dispatch(setFirstWeightRegister(weightState))
  }
}

export const setLastWeightRegisterAction = () => {
  return (dispatch, getState) => {
    const weightState = getState().weightData.allTimePatientData.data
    if (weightState?.length > 0) dispatch(setLastWeightRegister(weightState))
  }
}

export default weightStatsSlice.reducer